// import React from 'react'
// import cybercook from '../../../LOGO-PRODUCTO-removebg-preview.png'
// import { useState } from 'react';
// import { useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// function SignIn({setAdmin, admin}) {
//     const [changeUser, setChangeUser] = useState("")
//     const [changePassword, setChangePassword] = useState("")

// const navigate = useNavigate()

//     const PASSWORD1 = process.env.REACT_APP_PASSWORD1;
//     const PASSWORD2 = process.env.REACT_APP_PASSWORD2;
//     const USER1 = process.env.REACT_APP_USER1;
//     const USER2 = process.env.REACT_APP_USER2;

//     // capturar formulario

//     const changeUserFunction = (e) => {
//         setChangeUser(e.target.value)
//     }

//     const changePasswordFunction = (e) => {
//         setChangePassword(e.target.value)
//     }

// const submitFunction = (e) => {
//     e.preventDefault()
// if(changeUser === USER1){
//     if(changePassword === PASSWORD1){
//         setAdmin(true)
//     }
// }else if(changeUser === USER2){
//     if(changePassword === PASSWORD2){
//         setAdmin(true)
//     }
// }else{
//     alert("acceso denegado")
// }
// }

// useEffect(() => {
// if(admin === true){
//     navigate("/admin")
// }
// }, [admin])
//   return (
//     <div className='container-form-login'>

//         <form className='form-login' onSubmit={(e) => submitFunction(e)}>
//             <div className='cybercook-logo-container'>
// <img  src={cybercook} />
//             </div>
//             <div className='container-login-use'>
//             <input placeholder='usuario' onChange={changeUserFunction} />
//             <input placeholder='contraseña' onChange={changePasswordFunction} />
//             </div>
//             <button className='btn-initiated-sesion' type='submit'>Ingresar</button>
//             <div>
//                 <p>Si usted no hace parte del equipo de cybercook abandone este enlace.</p>
//             </div>
//         </form>
//     </div>
//   )
// }

// export default SignIn

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import cybercook from '../../../LOGO-PRODUCTO-removebg-preview.png';

function SignIn({ setAdmin, admin }) {
  const [changeUser, setChangeUser] = useState("");
  const [changePassword, setChangePassword] = useState("");
  const navigate = useNavigate();

  const PASSWORD1 = process.env.REACT_APP_PASSWORD1;
  const PASSWORD2 = process.env.REACT_APP_PASSWORD2;
  const USER1 = process.env.REACT_APP_USER1;
  const USER2 = process.env.REACT_APP_USER2;

  // Funciones para capturar los valores de los inputs
  const changeUserFunction = (e) => setChangeUser(e.target.value);
  const changePasswordFunction = (e) => setChangePassword(e.target.value);

  // Función que maneja el submit del formulario
  const submitFunction = (e) => {
    e.preventDefault();

    if (changeUser === USER1 && changePassword === PASSWORD1) {
      setAdmin(true); // Establece admin a true si las credenciales coinciden
    } else if (changeUser === USER2 && changePassword === PASSWORD2) {
      setAdmin(true);
    } else {
      alert("Acceso denegado");
    }
  };

  // Efecto para redirigir al usuario a "/admin" cuando se autentica correctamente
  useEffect(() => {
    if (admin) {
      navigate("/admin");
    }
  }, [admin]);

  return (
    <div className="container-form-login">
      <form className="form-login" onSubmit={submitFunction}>
        <div className="cybercook-logo-container">
          <img src={cybercook} alt="Logo de Cybercook" />
        </div>
        <div className="container-login-use">
          <input
            type="text"
            placeholder="Usuario"
            value={changeUser}
            onChange={changeUserFunction}
          />
          <input
            type="password"
            placeholder="Contraseña"
            value={changePassword}
            onChange={changePasswordFunction}
          />
        </div>
        <button className="btn-initiated-sesion" type="submit">
          Ingresar
        </button>
        <div>
          <p>Si usted no hace parte del equipo de Cybercook, abandone este enlace.</p>
        </div>
      </form>
    </div>
  );
}

export default SignIn;
